import React, { useState } from 'react';
import VolumesData from './data/volumesData';
import Footer from './Footer';
import { Modal, Button } from 'react-bootstrap';

function ScholarlyEdition() {
  const [selectedVolume, setSelectedVolume] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = (volumeId) => {
    setSelectedVolume(volumeId);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const volumeCaptions = {
    1: {
      title: 'Letters and Early Epistolary Writings',
      editor: 'Edited by Philip Barnard, Elizabeth Hewitt, Mark L. Kamrath, John R. Holmes, and Fritz Fleischmann, with William Dorner',
      published: 'Published April 2013',
      styled: true,
    },
    2: {
      title: 'The Monthly Magazine and Other Writings, 1789–1800',
      editor: 'Edited by Matthew Pethers, Leonard Von Morze, and Hilary Emmett',
      published: 'Approved by MLA-CSE March 2024',
      styled: false,
    },
    3: {
      title: 'The Literary Magazine and Other Writings, 1801–1807',
      editor: 'Edited by Robert Battistini, Michael Cody, and Karen Weyler',
      published: 'Published September 2019',
      styled: true,
    },
    4: {
      title: 'Political Pamphlets',
      editor: 'Edited by Mark L. Kamrath, Stephen Shapiro, and Maureen Tuthill',
      published: 'Published August 2020',
      styled: true,
    },
    5: {
      title: 'Historical Sketches and Fragments',
      editor: 'Edited by Philip Barnard and Yvette Piggush',
      published: 'Submit to MLA-CSE May 2025',
      styled: false,
    },
    6: {
      title: 'The American Register and Other Writings, 1807–1810',
      editor: 'Edited by Jared Gardner and Elizabeth Hewitt',
      published: 'Published September 2022',
      styled: true,
    },
    7: {
      title: 'Poems',
      editor: 'Edited by Michael Cohen and Alexandra Socarides',
      published: 'Published October 2020',
      styled: true,
    },
  };

  return (
    <div>
      <h1 className="page-header">
        Scholarly Edition: <em>Collected Writings of Charles Brockden Brown</em>
      </h1>
      <p>
        Bucknell University Press: 7 volumes<br />
        General Editor, Mark L. Kamrath<br />
        Textual Editor, Philip Barnard
      </p>
      <p>
        The volumes in this series all follow MLA-CSE guidelines for scholarly editions and receive
        additional vetting and certification from the CSE. They include Historical and Textual
        Essays, full textual apparatus, annotation, Appendices, and Indexes. The volumes will be
        available in print and electronic formats.
      </p>
      <p>
        The <strong>print</strong> volumes we intend to produce are as follows:
      </p>
      <div className="row">
        <div
          style={{
            borderBottom: '1px solid #ccc',
            paddingBottom: '15px',
            marginBottom: '15px',
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {[1, 2, 3, 4].map((vol) => {
            const caption = volumeCaptions[vol];
            return (
              <div className="col-sm-3 col-xs-12 volumeCaption" key={vol}>
                <div className="caption">
                  <h4>Volume {vol}</h4>
                  {caption && (
                    <>
                      <h4>{caption.title}</h4>
                      <p>{caption.editor}</p>
                      <p style={{ marginBottom: '0.5rem' }}>
                        {caption.styled ? (
                          <span style={{ color: '#993400', fontSize: '108%', fontWeight: 'bold' }}>
                            {caption.published}
                          </span>
                        ) : (
                          caption.published
                        )}
                      </p>

                    </>
                  )}
                  <button className="btn btn-primary m-1" onClick={() => handleOpenModal(vol)}>
                    Read More
                  </button>
                </div>
              </div>
            );
          })}
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {[5, 6, 7].map((vol) => {
            const caption = volumeCaptions[vol];
            return (
              <div className="col-sm-3 col-xs-12 volumeCaption" key={vol}>
                <div className="caption">
                  <h4>Volume {vol}</h4>
                  {caption && (
                    <>
                      <h4>{caption.title}</h4>
                      <p>{caption.editor}</p>
                      <p>
                        {caption.styled ? (
                          <span style={{ color: '#993400', fontSize: '108%', fontWeight: 'bold' }}>
                            {caption.published}
                          </span>
                        ) : (
                          caption.published
                        )}
                      </p>
                    </>
                  )}
                  <button className="btn btn-primary m-1" onClick={() => handleOpenModal(vol)}>
                    Read More
                  </button>
                </div>
              </div>
            );

          })}
        </div>
      </div>

      <Modal
        show={modalOpen}
        onHide={handleCloseModal}
        onExited={() => setSelectedVolume(null)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Volume {selectedVolume}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {VolumesData[selectedVolume] || <p>Details not available for this volume.</p>}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Footer />
    </div>
  );
}

export default ScholarlyEdition;
